import http from "@/utils/request";

/*
  用途：获取整改类别分类信息 (整改审批页面、非项目问题审批页面)
  请求方式：get
  参数：无 
*/
export function getProblemZgMeasuresData(){
    return http({
        url: "/api/job/v0.1/problemZgMeasures/measuresPage",
        method: "get"
    })
}

/*
  用途：获取整改数据信息 (整改审批页面、非项目问题审批页面)
  请求方式：get
  参数
  params：{
    id: guid    //
  }
*/
export function getViewByGuidData(guid){
    return http({
        url: "/api/job/v0.1/project/problem/getViewByGuid",
        method: "get",
        params: {
            id: guid
        }
    })
}

/*
  用途：获取整改数据信息 (整改审批页面、非项目问题审批页面)
  请求方式：get
  参数
  params：{
    guid: guid ,   //
    adopt: ""     //是否采纳
  }
*/
export function saveOrUpdate(data){
  return http({
      url: "/api/job/v0.1/project/problem/updateAdviseByPrimaryKeySelective",
      method: "post",
      data
  })
}


/*
  用途：获取风险详情数据 (整改审批页面、非项目问题审批页面)
  请求方式：get
  参数：风险guid  - riskGuid 
*/
export function getRiskDetailsData(riskGuid){
    return http({
        url: "/api/risk/v0.1/risk/getViewByGuid2",
        method: "get",
        params: {
            guid: riskGuid
        }
    })
}

/*
  用途：获取审批记录数据 (整改审批页面、非项目问题审批页面)
  请求方式：get
  参数：params: {
    businessKey:"",
  }
*/
export function getApprovalRecordData(wfGuid){
    return http({
        url: "/api/activiti/v0.1/workflow/getWorkFlowHis",
        method: "get",
        params:{
          businessKey:wfGuid
        }
    })
}

/*
  用途：通过路由参数guid获取整改审批记录的请求参数workflowguid (整改审批页面)
  请求方式：get (多参数版)
  参数：params: {
    problemGuid
  }
*/
export function getZgApplyWorkflowguid(problemGuid){
  return http({
      url: "/api/job/v0.1/project/problem/getZgApply",
      method: "get",
      params: {
        problemGuid
      }
  })
}

/*
  用途：获取审批记录数据 (整改审批页面、非项目问题审批等页面)
  请求方式：get (多参数版)
  参数：params: {
    businessKey:"",
    formKey:"",
    formVar:""
  }
*/
export function getApprovalRecordsData(params){
  return http({
      url: "/api/activiti/v0.1/workflow/getWorkFlow",
      method: "get",
      params
  })
}

/*
  用途：获取影响分类列表数据 (整改审批页面、非项目问题审批页面)
  请求方式：get
  参数：无
*/
export function getInfluenceListData(){
    return http({
        url: "/api/job/v0.1/problemInfluence/influencePage",
        method: "get"
    })
}

/*
  用途：获取上传的附件列表 (整改审批页面)
  请求方式：get
  参数：params: {
    tenant: "portal",
    fileIds
  }
*/
export function getFilesListData(fileIds){
    return http({
        url: "/api/store/v0.1/getUploadList",
        method: "get",
        params: {
            tenant: "portal",
            fileIds
        }
    })
}

/*
  用途：通过工号或者域账号查询用户信息 (整改审批页面、非项目问题审批页面)
  请求方式：get
  参数：params: {
    userKey: ""     //用户工号或者域账号
  }
*/
export function getUserInfo(userKey){
    return http({
        url: "/api/rbac/v0.1/common/getUserInfoByKey",
        method: "get",
        params: {
            userKey
        }
    })
}

/*
  用途：通过项目guid拿取项目信息 (立项审批页面、详版报告审批页面)
  请求方式：get
  参数：params: {
    projectId: ""     //项目guid
  }
*/
export function getProjectView(projectGuid){
    return http({
        url: "/api/job/v0.1/project/getProjectView",
        method: "get",
        params: {
            projectId: projectGuid
        }
    })
}

/*
  用途：通过项目ID找planId,等立项信息 (立项审批页面)
  请求方式：get
  参数：params: {
    projectGuid: ""     //项目guid
  }
*/
export function getPlanByProjectId(projectGuid){
    return http({
        url: "/api/job/v0.1/projectplan/getPlanByProjectId",
        method: "get",
        params: {
            projectGuid
        }
    })
}

/*
  用途：通过planId查询项目成员 (立项审批页面)
  请求方式：get
  参数：params: {
    projectPlanGuid: ""     //项目id
  }
*/
export function getListTeamByPlanGuid(planId){
    return http({
        url: "/api/job/v0.1/projectplan/getListTeamByPlanGuid",
        method: "get",
        params: {
            projectPlanGuid: planId
        }
    })
}

/*
  用途：通过项目guid查询风险列表 (立项审批页面)
  请求方式：post
  参数：无
*/
export function selectClueAndPlanAndRisk(projectGuid){
    return http({
        url: `/api/job/v0.1/projectplan/selectClueAndPlanAndRisk?projectId=${projectGuid}&clueType=1`,
        method: "post"
    })
}

/*
  用途：获取所有的项目文件id (立项审批页面)
  请求方式：get
  参数：params: {
    projectGuid: ""     //项目guid
  }
*/
export function getFileIdsData(projectGuid){
    return http({
        url: "/api/job/v0.1/project/getFileListById",
        method: "get",
        params: {
            projectGuid
        }
    })
}

/*
  用途：先判断有没有此阶段，或是否到达此阶段 (详版报告审批页面)
  请求方式：get
  参数：params: {
    id: ""     //项目id
    reportStage: 1  
  }
*/
export function getWfStatusByProjectGuidData(projectId){
    return http({
        url: "/api/job/v0.1/projectWorkFlow/getWfStatusByProjectGuid",
        method: "get",
        params: {
            projectGuid: projectId,
            stage: "cbbg"
        }
    })
}

/*
  用途：通过项目id获取项目信息 (详版报告审批页面)
  请求方式：get
  参数：params: {
    id: ""     //项目id
    reportStage: 1  
  }
*/
export function getDetailsReportData(projectId){
    return http({
        url: "/api/job/v0.1/projectReport/getViewByGuid",
        method: "get",
        params: {
            id: projectId,
            reportStage: 1
        }
    })
}

/*
  用途：通过项目id获取问题列表 (详版报告审批页面)
  请求方式：get
  参数：params: {
    projectGuid
  }
*/
export function getProblemListData(projectGuid){
    return http({
        url: "/api/job/v0.1/projectProblem/getProblemViewByProjectGuid",
        method: "get",
        params: {
            projectGuid
        }
    })
}


/*
  用途：通过项目guid获取审批记录id (详版报告审批页面)
  请求方式：get
  参数：params: {
    reportGuid: "",
    reportStage: "1"
  }
*/
export function getReportWorkFlowId(projectGuid){
    return http({
        url: "api/job/v0.1/projectReportWorkFlow/getInfo",
        method: "get",
        params: {
            reportGuid: projectGuid,
            reportStage: "1"
        }
    })
}